import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteProgramme } from "../api/programmesApi";
import { queryKeys } from "../lib/queryKeys";

export function useDeleteProgramme() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteProgramme(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.programmes.all });
    },
  });
}
